import React, { FunctionComponent, ReactNode } from 'react';
import { Paper, SxProps, Theme } from '@mui/material';

import { requireConfirmationToCancelInsertion } from '../../../../store/selectors/requireConfirmationToCancelInsertion';
import { useAppSelector } from '../../../hooks';
import { InsertCancelBar } from '../elements/InsertCancelBar';

interface Props {
  readonly className?: string;
  readonly sx?: SxProps<Theme>;
  readonly children: ReactNode;
  readonly disabled?: boolean;
  readonly hideSubmitButton?: boolean;
  readonly hideCancelButton?: boolean;

  readonly insertButtonText?: string;
  readonly onInsert?: () => void;

  readonly inlineAdditionalButtons?: boolean;
  readonly additionalButtons?: ReactNode;
}

const InsertionPanelContainer: FunctionComponent<Props> = (props) => {
  const requireConfirmation = useAppSelector(requireConfirmationToCancelInsertion);

  return (
    <>
      <Paper
        elevation={0}
        className={props.className}
        sx={[
          {
            overflowX: 'hidden',
            overflowY: 'auto',
            padding: 3,
            borderRadius: 0,
            marginBottom: 'auto',
            height: '100%',
          },

          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
      >
        {props.children}
      </Paper>
      <InsertCancelBar
        disabled={props.disabled}
        hideSubmitButton={props.hideSubmitButton}
        hideCancelButton={props.hideCancelButton}
        confirmCancelation={requireConfirmation}
        insertButtonText={props.insertButtonText}
        onInsert={props.onInsert}
        inlineChildren={props.inlineAdditionalButtons}
      >
        {props.additionalButtons}
      </InsertCancelBar>
    </>
  );
};

export default InsertionPanelContainer;
